// extracted by mini-css-extract-plugin
export default {"moniker":"Validators_moniker__xQjwj","muted":"Validators_muted__gNNKD","tooltip":"Validators_tooltip__aju0D","dlGap":"Validators_dlGap__sidV-"};